import React, { useEffect, useRef } from "react";

const ColorImageChanger = ({ imageSrc, targetColor, width = 300, height = '100%', mixRatio = 0 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.src = imageSrc;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      // 获取图片像素数据
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // 解析目标色值（支持 HEX 或 RGB 格式）
      let targetR, targetG, targetB;
      if (typeof targetColor === "string" && targetColor.startsWith("#")) {
        const hex = targetColor.replace("#", "");
        targetR = parseInt(hex.substring(0, 2), 16);
        targetG = parseInt(hex.substring(2, 4), 16);
        targetB = parseInt(hex.substring(4, 6), 16);
      } else if (Array.isArray(targetColor)) {
        [targetR, targetG, targetB] = targetColor;
      } else {
        // 默认色值
        targetR = 0;
        targetG = 0;
        targetB = 0;
      }

      // 修改非透明像素的颜色
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha > 0) { // 只处理非完全透明的像素
          if (mixRatio > 0 && mixRatio <= 1) {
            // 混合原始颜色和目标颜色
            data[i] = Math.round(targetR * mixRatio + data[i] * (1 - mixRatio));         // 红色
            data[i + 1] = Math.round(targetG * mixRatio + data[i + 1] * (1 - mixRatio)); // 绿色
            data[i + 2] = Math.round(targetB * mixRatio + data[i + 2] * (1 - mixRatio)); // 蓝色
          } else {
            // 完全替换为目标颜色
            data[i] = targetR;     // 红色
            data[i + 1] = targetG; // 绿色
            data[i + 2] = targetB; // 蓝色
          }
          // 透明度保持不变
        }
      }

      // 将修改后的数据放回画布
      ctx.putImageData(imageData, 0, 0);
    };
  }, [imageSrc, targetColor, mixRatio]);

  return (
    <canvas
      ref={canvasRef}
      style={{ width: width ,height:height}}
    />
  );
};

export default ColorImageChanger;